import {
  IRowPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
} from "@tedivo/tedivo-bay-grid-pure";

import { ICreateSimpleSideViewProps } from "../useSimpleSideView";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { getAllContainers } from "./getAllContainers";
import { getContainersByMaxSizePerStack } from "./getContainersByMaxSizePerStack";
import { getRowContainers } from "./getPerRowContainers";
import { getSideContainers } from "./getSideContainers";

export function obtainFilterFn(
  selectContainerCriteria: ICreateSimpleSideViewProps["selectContainerCriteria"],
): TObtainFilterFnOutput {
  switch (selectContainerCriteria) {
    case "maxSize":
      return getContainersByMaxSizePerStack;
    case "all":
      return getAllContainers;
    case "portOuter":
      return getSideContainers("port");
    case "stbdOuter":
      return getSideContainers("starboard");
    default:
      return getRowContainers(selectContainerCriteria as IRowPattern);
  }
}

export type TObtainFilterFnOutput = (
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
) => TGetContainersFilterOutput;
